module.exports = __webpack_public_path__ + "static/media/image_swap.0140fac4.svg";